import { AUTO, DEFAULT_CONNECTION_BACKGROUND } from './../constants';
import { deepExtend } from './../utils/deep-extend';
import { Point } from './../math/Shapes';
const defaultOptions = {
    width: 10,
    height: 10,
    fill: {
        color: DEFAULT_CONNECTION_BACKGROUND
    },
    hover: {
        stroke: {
            width: 1
        }
    },
    offset: 10
};
export class Connector {
    /**
     * Creates a new Connector instance.
     * @param shape The shape that owns this connector
     * @param options Configuration options for the connector
     */
    constructor(shape, options) {
        this.options = deepExtend({}, defaultOptions, options);
        this.connections = [];
        this.shape = shape;
    }
    /**
     * Gets the position of this connector.
     * Uses either a custom position function from options or the shape's getPosition method.
     * Applies offset if configured.
     * @returns The Point representing the connector's position
     */
    position() {
        let pos;
        if (this.options.position) {
            pos = this.options.position(this.shape);
        }
        else {
            pos = this.shape.getPosition(this.options.name);
        }
        // Apply offset if configured
        if (this.options.offset) {
            const offset = this._calculateOffset();
            pos = pos.plus(offset);
        }
        return pos;
    }
    /**
     * @hidden
     *
     * Gets the position of this connector without applying offset.
     * Used for connection rendering to draw the connection from the shape edge.
     * @returns The Point representing the connector's position without offset
     */
    positionWithoutOffset() {
        if (this.options.position) {
            return this.options.position(this.shape);
        }
        else {
            return this.shape.getPosition(this.options.name);
        }
    }
    /**
     * @hidden
     * Calculates the offset vector based on connector name and configured offset value.
     * @returns Point representing the offset direction and magnitude
     */
    _calculateOffset() {
        const offset = this.options.offset || 0;
        const name = (this.options.name || '').toLowerCase();
        // const Point = this.shape.bounds().topLeft().constructor;
        switch (name) {
            case 'top':
                return new Point(0, -offset);
            case 'bottom':
                return new Point(0, offset);
            case 'left':
                return new Point(-offset, 0);
            case 'right':
                return new Point(offset, 0);
            default:
                return new Point(0, 0);
        }
    }
    /**
     * Converts the connector to a JSON representation for serialization.
     * @returns Object containing the shape ID and connector name
     */
    toJSON() {
        return {
            shapeId: this.shape.toString(),
            connector: this.options.name
        };
    }
    /**
     * @hidden
     * Parses a string representation to find and return a connector from the diagram.
     * @param diagram The diagram to search for the connector
     * @param str String representation in format "shapeId:connectorName"
     * @returns The matching Connector or undefined if not found
     */
    static parse(diagram, str) {
        const tempStr = str.split(':'), id = tempStr[0], name = tempStr[1] || AUTO;
        for (let i = 0; i < diagram.shapes.length; i++) {
            const shape = diagram.shapes[i];
            if (shape.options.id === id) {
                return shape.getConnector(name.trim());
            }
        }
    }
    ;
}
